export default "__VITE_ASSET__YlQWrSDK__"